import { createStore } from 'vuex'

export default createStore({
    state: {
        aid: '63106fee371b6b0042433246', // 活动id
        musicPaused: false, // 音乐播放状态
        userInfo: {}, // 用户信息
        shareData: {}, // 分享信息
        dialogData: null, // 弹框数据
        activityData: null // 活动数据
    },
    mutations: {
        SET_MUSICPAUSED (state, flag: boolean) {
            state.musicPaused = flag
        },
        SET_USERINFO (state, data) {
            state.userInfo = data
        },
        SET_SHAREDATA (state, data) {
            state.shareData = data
        },
        SET_DIALOGDATA (state, data) {
            state.dialogData = data
        },
        SET_ACTIVITYDATA (state, data) {
            state.activityData = data
        }
    },
    actions: {
    },
    modules: {
    }
})
